import React, { useEffect, useRef, useState } from "react";
import styles from "../../styles/profile.module.css";
import { Formik, Form, useFormikContext } from "formik";
import * as Yup from "yup";
import { allCountrys, errorContainer, formAttr, formAttrNumber } from "../common/CommonFun";
import { GetTokenApi, PostTokenApi } from "../../api/api-service";
import { API_Path, apiBaseUrlImg, validNumberRegex } from "../../const";
import Loading from "../loader/Loading";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";
import moment from "moment";
import usePageTitle from "../customHook/usePageTitle";

var startdate = moment().subtract(13, "years").format("YYYY-MM-DD");
var dataOFPersonal = "";
var kycData = 0;

export default function PersonalInfo(props) {
    const navigate = useNavigate();
    usePageTitle("User Account", true);
    const selectRef = useRef(null);
    const [focus, setFocus] = useState(false);
    const [isActive, setIsActive] = useState(false);
    const [selectedOption, setSelectedOption] = useState("Select country");
    const [selectedName, setSelectedName] = useState("");
    const [searchQuery, setSearchQuery] = useState("");
    const [useKycDetailsData, setUserKycDetailsData] = useState({ ...dataOFPersonal });
    const [loading, setLoading] = useState(false);
    const [btnLoading, setBTNLoading] = useState(false);
    const [kycStep, setKycStep] = useState(kycData);
    const today = new Date();
    const minDate = new Date(today.setFullYear(today.getFullYear() - 18));
    useEffect(() => {
        getUserKYCProfile();
    }, []);

    const getUserKYCProfile = () => {
        setLoading(true);
        const getCryptoCurrency = new Promise((resolve) => {
            resolve(GetTokenApi(API_Path.getUserKycProfile));
        });
        getCryptoCurrency.then((res) => {
            setLoading(false);
            if (res) {
                dataOFPersonal = res.data;
                if (dataOFPersonal.Id > 0) kycData = 2;
                else kycData = 1;
                setKycStep(kycData);
                setUserKycDetailsData(dataOFPersonal);
            } else toast.error("Something went wrong!");
        });
    };

    const setSubmitData = (formdata, resetform) => {
        setBTNLoading(true);
        const CountryCode = allCountrys.find((data) => data.name === formdata.Country);
        const data = {
            ...formdata,
            DateOfBirth: moment(formdata.DateOfBirth, "YYYY-MM-DD").format("DD-MM-YYYY"),
            CountryCode: CountryCode.value,
        };
        let editProfile = new Promise((resolve) => {
            resolve(PostTokenApi(API_Path.userKYCProfileUpload, data));
        });
        editProfile.then((res) => {
            if (res.data.Isvalid) {
                toast.success(res.data.Successes[0]);
                getUserKYCProfile();
                resetform();
            } else toast.error(res.data.Errors[0]);
            setBTNLoading(false);
        });
    };

    const handleEditProfile = () => setKycStep(1);
    const handleRedirect = () => navigate("/useraccount/profile/user-kyc");

    const handleOptionClick = (value) => {
        setSelectedOption(
            <>
                <img src={apiBaseUrlImg + value.image} alt="" className="img_flag" /> {value.name}
            </>
        );
        setSelectedName(value.name);
        setIsActive(false);
    };

    const handleSelectClick = () => setIsActive(!isActive);

    useEffect(() => {
        document.addEventListener("click", handleDocumentClick);
        return () => {
            document.removeEventListener("click", handleDocumentClick);
        };
    }, []);

    const handleDocumentClick = (e) => {
        if (selectRef.current && !selectRef.current.contains(e.target)) setIsActive(false);
    };

    const filteredCoinData = allCountrys.filter((item) => item.name.toLowerCase().includes(searchQuery.toLowerCase()) || item.number.toLowerCase().includes(searchQuery.toLowerCase()));

    const handleFocus = () => {
        if (!focus) setFocus(true);
    };

    return (
        <React.Fragment>
            {loading && <Loading />}
            <div className={styles.personal_info_body}>
                <div className="text-end">
                    <button className={`${styles.button} ${styles.button_border} w-auto me-0 mb-3`} onClick={() => navigate("/useraccount/profile/user-info")}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="me-2" viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8" />
                        </svg>
                        Back
                    </button>
                </div>
                {kycStep === 1 && (
                    <div className={`${styles.account_box}`}>
                        <Formik
                            initialValues={{
                                FirstName: useKycDetailsData?.FirstName ?? "",
                                MiddleName: useKycDetailsData?.MiddleName ?? "",
                                LastName: useKycDetailsData?.LastName ?? "",
                                DateOfBirth: useKycDetailsData?.DateOfBirth ? moment(useKycDetailsData?.DateOfBirth, "DD/MM/YYYY").format("YYYY-MM-DD") : "",
                                MobileNo: useKycDetailsData?.MobileNo ? useKycDetailsData?.MobileNo : "",
                                Address: useKycDetailsData?.Address ?? "",
                                City: useKycDetailsData?.City ?? "",
                                State: useKycDetailsData?.State ?? "",
                                Country: useKycDetailsData?.Country ?? "",
                                PinCode: useKycDetailsData?.PinCode ? useKycDetailsData?.PinCode : "",
                                CountryCode: useKycDetailsData?.CountryCode ?? "",
                            }}
                            validationSchema={Yup.object().shape({
                                FirstName: Yup.string()
                                    .matches(/^[A-Za-z ]+$/, "First name can contain only alphabets and space.")
                                    .required("First name is required."),
                                MiddleName: Yup.string().matches(/^[A-Za-z ]+$/, "Middle name can contain only alphabets and space."),
                                LastName: Yup.string()
                                    .matches(/^[A-Za-z ]+$/, "Last name can contain only alphabets and space.")
                                    .required("Last name is required."),
                                DateOfBirth: Yup.string()
                                    .required("Date of Birth is required.")
                                    .test("age", "You must be at least 18 years old", (value) => {
                                        const birthDate = new Date(value);
                                        return birthDate <= minDate; // Check if the entered date is before 18 years ago
                                    }),
                                MobileNo: Yup.string().required("Mobile No. is required."),
                                Address: Yup.string().required("Address is required."),
                                City: Yup.string()
                                    .matches(/^[A-Za-z ]+$/, "City name can contain only alphabets and space.")
                                    .required("City is required."),
                                State: Yup.string()
                                    .matches(/^[A-Za-z ]+$/, "State name can contain only alphabets and space.")
                                    .required("State is required."),
                                Country: Yup.string().required("Country is required."),
                                PinCode: Yup.string().required("PIN/ZIP Code is required."),
                            })}
                            initialTouched={false}
                            validateOnChange={true}
                            validateOnBlur={true}
                            onSubmit={async (values, { resetForm }) => {
                                setSubmitData(values, resetForm);
                            }}
                        >
                            {(runform) => {
                                const { touched, errors, setFieldValue, validateForm } = runform;
                                return (
                                    <Form onSubmit={runform.handleSubmit}>
                                        <div className={styles.title}>
                                            <h6>Personal Info</h6>
                                        </div>
                                        <div className={styles.personalinfo_width}>
                                            <div className={styles.personalinfocontent}>
                                                <label>
                                                    First name
                                                    <span className={styles.asterisk}>*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    name="FirstName"
                                                    className={`${styles.form_input}${errors.FirstName && touched.FirstName ? " input-error" : ""} ${focus ? "input_focus" : ""}`}
                                                    placeholder="Enter your full name"
                                                    maxLength="50"
                                                    onFocus={handleFocus}
                                                    {...formAttr(runform, "FirstName")}
                                                />
                                                {errorContainer(runform, "FirstName")}
                                            </div>
                                            <div className={styles.personalinfocontent}>
                                                <label>Middle name</label>
                                                <input
                                                    type="text"
                                                    name="MiddleName"
                                                    {...formAttr(runform, "MiddleName")}
                                                    className={`${styles.form_input}${errors.MiddleName && touched.MiddleName ? " input-error" : ""}`}
                                                    placeholder="Enter your middle name"
                                                    maxLength="50"
                                                />
                                                {errorContainer(runform, "MiddleName")}
                                            </div>
                                            <div className={styles.personalinfocontent}>
                                                <label>
                                                    Last name
                                                    <span className={styles.asterisk}>*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    name="LastName"
                                                    {...formAttr(runform, "LastName")}
                                                    className={`${styles.form_input}${errors.LastName && touched.LastName ? " input-error" : ""}`}
                                                    placeholder="Enter your last name"
                                                    maxLength="50"
                                                />
                                                {errorContainer(runform, "LastName")}
                                            </div>
                                            <div className={styles.personalinfocontent}>
                                                <label>
                                                    Date of birth
                                                    <span className={styles.asterisk}>*</span>
                                                </label>
                                                <input
                                                    type="date"
                                                    name="DateOfBirth"
                                                    id="dataID"
                                                    max={startdate}
                                                    {...formAttr(runform, "DateOfBirth")}
                                                    className={`${styles.form_input}${errors.DateOfBirth && touched.DateOfBirth ? " input-error" : ""}`}
                                                />
                                                {errorContainer(runform, "DateOfBirth")}
                                            </div>
                                            <div className={styles.personalinfocontent}>
                                                <label>
                                                    Mobile No.
                                                    <span className={styles.asterisk}>*</span>
                                                </label>
                                                <input
                                                    type="tel"
                                                    name="MobileNo"
                                                    className={`${styles.form_input}${errors.MobileNo && touched.MobileNo ? " input-error" : ""}`}
                                                    placeholder="xxxxx xxxxx"
                                                    maxLength="20"
                                                    {...formAttrNumber(runform, "MobileNo")}
                                                />
                                                {errorContainer(runform, "MobileNo")}
                                            </div>
                                        </div>
                                        <div className={`${styles.title} mt-4`}>
                                            <h6 className="mt-4">Contact Info</h6>
                                        </div>
                                        <div className={styles.personalinfo_width}>
                                            <div className={styles.personalinfocontent}>
                                                <label>
                                                    Address<span className={styles.asterisk}>*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    name="Address"
                                                    {...formAttr(runform, "Address")}
                                                    className={`${styles.form_input}${errors.Address && touched.Address ? " input-error" : ""}`}
                                                    placeholder="Plot no., Flor no., Street Name"
                                                    maxLength="100"
                                                />
                                                {errorContainer(runform, "Address")}
                                            </div>
                                            <div className={styles.personalinfocontent}>
                                                <label>
                                                    City
                                                    <span className={styles.asterisk}>*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    name="City"
                                                    {...formAttr(runform, "City")}
                                                    className={`${styles.form_input}${errors.City && touched.City ? " input-error" : ""}`}
                                                    placeholder="City"
                                                    maxLength="20"
                                                />
                                                {errorContainer(runform, "City")}
                                            </div>
                                            <div className={styles.personalinfocontent}>
                                                <label>
                                                    State
                                                    <span className={styles.asterisk}>*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    name="State"
                                                    {...formAttr(runform, "State")}
                                                    className={`${styles.form_input}${errors.State && touched.State ? " input-error" : ""}`}
                                                    placeholder="State"
                                                    maxLength="20"
                                                />
                                                {errorContainer(runform, "State")}
                                            </div>
                                            <div className={styles.personalinfocontent}>
                                                <label>
                                                    Country
                                                    <span className={styles.asterisk}>*</span>
                                                </label>
                                                <div className="select" ref={selectRef}>
                                                    <div
                                                        className={`select-styled ${isActive ? "active" : ""} ${errors.Country && touched.Country ? "input-error" : ""}`}
                                                        onClick={() => {
                                                            handleSelectClick();
                                                            setSearchQuery("");
                                                        }}
                                                    >
                                                        {selectedOption != "Select country" ? selectedOption : useKycDetailsData?.Country ? useKycDetailsData?.Country : "Select country"}
                                                    </div>
                                                    {isActive && (
                                                        <div className={styles.country_option}>
                                                            <div className={`${styles.serach_countryName} text-center`}>
                                                                <input type="search" placeholder="search" value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} maxLength={40} />
                                                            </div>
                                                            <ul className="select-options">
                                                                {filteredCoinData.map((option, i) => (
                                                                    <li
                                                                        key={i}
                                                                        onClick={() => {
                                                                            runform.setFieldValue("Country", option.name);
                                                                            handleOptionClick(option);
                                                                        }}
                                                                        name="Country"
                                                                        className={selectedName == option.name ? "is-selected" : ""}
                                                                    >
                                                                        <img src={apiBaseUrlImg + option.image} className="img_flag" alt="" /> {option.name}
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        </div>
                                                    )}
                                                </div>
                                                {errorContainer(runform, "Country")}
                                            </div>
                                            <div className={styles.personalinfocontent}>
                                                <label>
                                                    Pin/Zip Code
                                                    <span className={styles.asterisk}>*</span>
                                                </label>
                                                <input
                                                    type="tel"
                                                    name="PinCode"
                                                    className={`${styles.form_input}${errors.PinCode && touched.PinCode ? " input-error" : ""}`}
                                                    placeholder="Pin/Zip Code"
                                                    maxLength="10"
                                                    {...formAttrNumber(runform, "PinCode")}
                                                />
                                                {errorContainer(runform, "PinCode")}
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className={`${styles.personal_info_btn} text-center d-flex`}>
                                                <button
                                                    type="button"
                                                    className={`${styles.button} ${styles.button_border}`}
                                                    onClick={() => {
                                                        runform.resetForm();
                                                        setSelectedOption("Select country");
                                                        if (useKycDetailsData?.Id != 0) setKycStep(2);
                                                    }}
                                                >
                                                    {useKycDetailsData?.Id == 0 ? "Clear" : "Cancel"}
                                                </button>
                                                <button type="submit" className={`${styles.button} primary_button`} disabled={btnLoading}>
                                                    Submit
                                                    {btnLoading && <span className="spinner-border spinner-border-sm ms-2" role="status" aria-hidden="true"></span>}
                                                </button>
                                            </div>
                                        </div>
                                    </Form>
                                );
                            }}
                        </Formik>
                    </div>
                )}
                {kycStep === 2 && (
                    <div className="row">
                        <div className="col-12 personal-info-main">
                            <div className="row">
                                <div className="col-12 col-sm-6">
                                    <div className={`${styles.detatils_white_box} h-100 ${styles.details_info_box}`}>
                                        <div className={styles.title}>
                                            <h6>Personal Info</h6>
                                        </div>
                                        <div className={styles.personal_details}>
                                            <ul>
                                                <li>
                                                    <b>First Name</b>
                                                    <span>{useKycDetailsData?.FirstName}</span>
                                                </li>
                                                <li>
                                                    <b>Middle Name</b>
                                                    <span>{useKycDetailsData?.MiddleName ?? ""}</span>
                                                </li>
                                                <li>
                                                    <b>Last Name</b>
                                                    <span>{useKycDetailsData?.LastName}</span>
                                                </li>
                                                <li>
                                                    <b>Date of Birth</b>
                                                    <span>{useKycDetailsData?.DateOfBirth}</span>
                                                </li>
                                                <li>
                                                    <b>Mobile No.</b>
                                                    <span>{useKycDetailsData?.MobileNo}</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-sm-6">
                                    <div className={`${styles.detatils_white_box} h-100`}>
                                        <div className={styles.title}>
                                            <h6>Contact Info</h6>
                                        </div>
                                        <div className={styles.personal_details}>
                                            <ul>
                                                <li>
                                                    <b>Address</b>
                                                    <span>{useKycDetailsData?.Address}</span>
                                                </li>
                                                <li>
                                                    <b>City</b>
                                                    <span>{useKycDetailsData?.City ?? ""}</span>
                                                </li>
                                                <li>
                                                    <b>State</b>
                                                    <span>{useKycDetailsData?.State}</span>
                                                </li>
                                                <li>
                                                    <b>Country</b>
                                                    <span>{useKycDetailsData?.Country}</span>
                                                </li>
                                                <li>
                                                    <b>Pin/Zip code</b>
                                                    <span>{useKycDetailsData?.PinCode}</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {(useKycDetailsData.DocStatus == 0  || useKycDetailsData.DocStatus == 3)&& (
                            <div className={`${styles.personal_info_btn} text-center d-flex`}>
                                <button type="button" className={`${styles.button} ${styles.button_border}`} onClick={() => handleEditProfile()}>
                                    Edit Profile
                                </button>
                                <button type="submit" className={`${styles.button} primary_button`} onClick={handleRedirect}>
                                    Complete KYC
                                </button>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </React.Fragment>
    );
}
